import { SPONSORS } from "../data/site";

export default function Sponsors() {
  return (
    <div
      data-testid="sponsors-grid"
      className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4"
    >
      {SPONSORS.map((s, i) => (
        <a
          key={s.name}
          href={s.url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`sponsor-${i}`}
          className={`group h-28 sm:h-32 rounded-2xl bg-white border border-[#ebd9b5] hover:border-[#ed6a1a] hover:shadow-md transition-all duration-300 flex items-center justify-center ${
            s.prominent ? "p-2 sm:p-2.5" : s.enlarge ? "p-1.5 sm:p-2" : s.medium ? "p-2 sm:p-2.5" : "p-3 sm:p-4"
          }`}
          title={s.name}
        >
          <img
            src={s.logo}
            alt={s.name}
            loading="lazy"
            style={s.darkBg ? { filter: "invert(1) hue-rotate(180deg)" } : undefined}
            className={`${
              s.prominent
                ? "max-h-[95%] max-w-[95%]"
                : s.enlarge
                  ? "max-h-[110%] max-w-[110%] scale-[1.18]"
                  : s.medium
                    ? "max-h-[88%] max-w-[90%]"
                    : "max-h-[72%] max-w-[80%]"
            } object-contain transition-transform duration-300 group-hover:scale-105`}
          />
        </a>
      ))}
    </div>
  );
}
